import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/dashboardTemplates'
import Component from 'components/DashboardTemplates'

export default createListViewContainer({ actions, selectors: selectors.dashboardTemplates })(Component)
